import React from 'react'
import { Button, Grid } from '@mui/joy';
import { Box,Typography } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';

const amount = ['2,225.61', '2,225.61', '2,225.61', '2,225.61', '2,225.61',]

const ProfileAmountCard = () => {
    return (
        <>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {
                    amount.map((data, index) => {
                        return (
                            <Grid item xs={6} key={index}>
                                <Box
                                    sx={{
                                        border: "1px solid #28A745",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: '172px',
                                        width: '294px',
                                        margin: "auto", // Center the box within the page
                                        textAlign: "center",
                                        borderRadius: "1px",
                                    }}
                                >
                                    <img width={45} height={45} src="assets/images/icons/Asset 1.png" alt="" />
                                    <Typography variant="h5">
                                        £ {data}
                                    </Typography>
                                    <Typography variant="h6" >
                                        Total Spend
                                    </Typography>
                                    <Typography variant="body">
                                        Refresh
                                    </Typography>

                                </Box>
                            </Grid>
                        )
                    })
                }


            </Grid>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",  // Centers the boxes horizontally
                    alignItems: "center",       // Centers vertically (if needed)
                    gap: 2,                     // Space between boxes
                    flexWrap: "wrap",            // Allows wrapping on smaller screens
                    marginTop: 4,
                }}
            >
                {[1, 2, 3].map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: "225px",
                            height: "96px",
                            border: "1px solid #28A745",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            borderRadius: "1px",
                        }}
                    >
                        <Typography variant="h6">Total Bid{item}</Typography>
                        <Typography variant="body1">Refresh</Typography>
                    </Box>
                ))}
            </Box>

        </>
    )
}

export default ProfileAmountCard;


export const ProfileWallet = () => {
    return (
        <>
            <Box
                sx={{
                    width: '94%',  
                    height: '100%', 
                    display: "flex",          
                    justifyContent: "end",  
                    alignItems: "end",
                    mb: "16px",
                   
                }}
            >         
                <Button
                    sx={{
                        backgroundColor: '#28A745',
                        color: '#fff',
                        width: '194px',
                        height: '39px',
                        borderRadius: '6px',
                        fontSize: '18px',
                        fontWeight: 500,
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        "&:hover": {
                            backgroundColor: "#218838",
                        }
                    }}
                >
                    <AddIcon sx={{ fontSize: 28, color: "#fff" }} />
                    <Typography sx={{ fontSize: '18px', color: '#fff', fontWeight: 500 }}>
                    Add Amount
                    </Typography>
                </Button>
            </Box>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

                {
                    amount.map((data, index) => {
                        return (
                            <Grid item xs={6} key={index}>
                                <Box
                                    sx={{
                                        border: "1px solid #28A745",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: '172px',
                                        width: '294px',
                                        margin: "auto", // Center the box within the page
                                        textAlign: "center",
                                        borderRadius: "1px",
                                    }}
                                >
                                    <img width={45} height={45} src="assets/images/icons/Asset 1.png" alt="" />
                                    <Typography variant="h5">
                                        £ {data}
                                    </Typography>
                                    <Typography variant="h6" >
                                        Total Spend
                                    </Typography>
                                    <Typography variant="body">
                                        Refresh
                                    </Typography>

                                </Box>
                            </Grid>
                        )
                    })
                }


            </Grid>



        </>
    )
}

